import React from 'react';
import { Events } from 'components/events/Events';

export const Component = () => {
  return (
    <Events
      upcomingTitle="Upcoming events"
      previousTitle="Previous events"
      items={[
        {
          title: 'Future event',
          startDate: '2022-05-22T16:00:00+0000',
          endDate: '2022-05-22T20:00:00+0000',
          addressString: 'Suðurlandsbraut 6 108, Reykjavik Iceland',
          booth: 'J-04',
          link: { href: 'https://kodo.is' },
        },
        {
          title: 'Future event',
          startDate: '2022-06-10T16:00:00+0000',
          endDate: '2022-06-10T20:00:00+0000',
          addressString: 'Suðurlandsbraut 6 108, Reykjavik Iceland',
          booth: 'J-04',
          link: { href: 'https://kodo.is' },
        },
        {
          title: 'Future event',
          startDate: '2022-07-03T16:00:00+0000',
          endDate: '2022-07-03T20:00:00+0000',
          addressString: 'Suðurlandsbraut 6 108, Reykjavik Iceland',
          booth: 'J-04',
          link: { href: 'https://kodo.is' },
        },
        {
          title: 'Future event',
          startDate: '2022-09-01T16:00:00+0000',
          endDate: '2022-09-01T20:00:00+0000',
          addressString: 'Suðurlandsbraut 6 108, Reykjavik Iceland',
          booth: 'J-04',
          link: { href: 'https://kodo.is' },
        },
        {
          title: 'Past event',
          startDate: '2021-09-01T16:00:00+0000',
          endDate: '2021-09-01T20:00:00+0000',
          addressString: 'Suðurlandsbraut 6 108, Reykjavik Iceland',
          booth: 'J-04',
          link: { href: 'https://kodo.is' },
          investorPresentation: {
            href:
              'https://prismic-io.s3.amazonaws.com/lotus/f3eb8a15-8fa1-4a48-a337-67256dd8be61_Aug21press-releasefinal.pdf',
          },
        },
        {
          title: 'Past event',
          startDate: '2021-07-03T16:00:00+0000',
          endDate: '2021-07-03T20:00:00+0000',
          addressString: 'Suðurlandsbraut 6 108, Reykjavik Iceland',
          booth: 'J-04',
          link: { href: 'https://kodo.is' },
          investorPresentation: {
            href:
              'https://prismic-io.s3.amazonaws.com/lotus/f3eb8a15-8fa1-4a48-a337-67256dd8be61_Aug21press-releasefinal.pdf',
          },
        },
      ]}
    />
  );
};
